import { useMemo } from 'react';

import { MainText } from '@/components/Typography/NamedTypo';
import { readableFormat } from '@/utils/time';

type Props = {
  date?: string;
};

const DateRowChildren = (props: Props) => {
  const date = useMemo(() => {
    return props.date === '' ? '-' : readableFormat(props.date);
  }, [props.date]);

  return <MainText>{date}</MainText>;
};

export default DateRowChildren;
